import { Employee } from '../../interfaces/Employee';
import { formatCents, payoutCents } from '../../utils/amounts';
import Modal from '../modal/Modal';
import './PayoutConfirm.css';

interface PayoutConfirmProps {
  employees: Employee[];
  totalCents: number;
  /** Баланс контракта в токенах; `null` — не прочитался. */
  contractBalance: number | null;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Последний экран перед выплатой всем. Раньше один клик по «Выплатить всем»
 * сразу открывал кошелёк — без суммы перед глазами.
 *
 * Блокирует подтверждение там, где контракт заведомо откатит всю транзакцию:
 * не хватает баланса или у кого-то выплата меньше нуля (штраф больше оклада с
 * премией — особенность №3 в доке контракта). Газ за откат всё равно
 * списался бы.
 */
const PayoutConfirm = ({
  employees,
  totalCents,
  contractBalance,
  onConfirm,
  onCancel,
}: PayoutConfirmProps) => {
  const negative = employees.filter((employee) => payoutCents(employee) < 0);
  const shortOfBalance =
    contractBalance !== null && contractBalance * 100 < totalCents;

  return (
    <Modal
      title="Подтвердите выплату всем"
      onClose={onCancel}
      className="payout_confirm"
    >
      <div className="payout_confirm__rows">
        <div className="payout_confirm__row">
          <span>Сотрудников</span>
          <strong>{employees.length}</strong>
        </div>
        <div className="payout_confirm__row">
          <span>Сумма выплаты</span>
          <strong>{formatCents(totalCents)} EMIVN</strong>
        </div>
        <div className="payout_confirm__row">
          <span>Баланс контракта</span>
          <strong>
            {contractBalance === null
              ? 'не прочитан'
              : `${formatCents(contractBalance * 100)} EMIVN`}
          </strong>
        </div>
      </div>

      <p>
        После выплаты премии и штрафы всех сотрудников обнулятся, оклады
        останутся. Кошелёк попросит подпись для базы, затем — транзакцию.
      </p>

      {shortOfBalance && (
        <p className="payout_confirm__error">
          На контракте не хватает токенов — транзакция откатится целиком.
        </p>
      )}

      {negative.length > 0 && (
        <p className="payout_confirm__error">
          Выплата меньше нуля у:{' '}
          {negative.map((employee) => employee.full_name).join(', ')}. Контракт
          откатит транзакцию — сначала поправьте штраф.
        </p>
      )}

      <div className="payout_confirm__actions">
        <button onClick={onCancel}>Отмена</button>
        <button
          onClick={onConfirm}
          disabled={shortOfBalance || negative.length > 0}
        >
          Выплатить
        </button>
      </div>
    </Modal>
  );
};

export default PayoutConfirm;
